import { useEffect, useState } from 'react';
import { customPayRunGateway } from '../index';
import { formatDateTime } from '../../payroll-review/formatting';
import type { DuplicateAcknowledgementResponse } from '../types';
import { describeOtherRun, matchLabel } from './duplicateText';

/** For the approver: employees the preparer confirmed are also in another run for the same period or pay day, with the reason, who and when.
 * Read from the run's audit trail. Shown only when there is at least one. */
export function DuplicateAcknowledgementsPanel({ runId }: { runId: string }) {
  const [items, setItems] = useState<DuplicateAcknowledgementResponse[]>([]);

  useEffect(() => {
    const controller = new AbortController();
    customPayRunGateway
      .getDuplicateAcknowledgements(runId, controller.signal)
      .then((rows) => {
        if (!controller.signal.aborted) setItems(rows);
      })
      .catch(() => undefined); // context only: a missing read permission just hides it
    return () => controller.abort();
  }, [runId]);

  if (items.length === 0) return null;
  return (
    <div className="cpr-notice cpr-notice--warning" role="region" aria-label="Duplicate pay acknowledgements" data-testid="duplicate-acknowledgements">
      <strong>The preparer confirmed these employees are also in another run for this period or pay day</strong>
      <ul>
        {items.map((a) => (
          <li key={`${a.employeeId}-${a.otherRunId}`}>
            <strong>{a.employeeName}</strong> — {describeOtherRun(a)}, {matchLabel(a.match)}.
            {a.acknowledgesApprovedRun && <strong> The preparer acknowledged that the other run is already approved.</strong>}
            <br />
            Reason: “{a.reason}” — {a.acknowledgedByEmail ?? 'a user'}, {formatDateTime(a.acknowledgedAtUtc)}
          </li>
        ))}
      </ul>
    </div>
  );
}
